export default __webpack_public_path__ + "static/fira-sans-regular-d9506f36795a08de33aac697918f030c.woff2";